import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import {
  api_v3_register,
  api_v3_user_register_tournament,
  current_background_video,
} from "../utils/constants";
import { useLocation, Link } from "react-router-dom";
import { Loading, RegisterTournamentOk } from "../components";

import { useNavContext } from "../context/nav_context";

const RegisterTournamentOkPage = () => {
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
  const location = useLocation();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [tournamentId, setTournamentId] = useState();

  const { setAuthTokens } = useNavContext();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setCode(params.get("code"));
    setTournamentId(params.get("state"));
    if (!params.get("code")) {
      setError("¿Has iniciado sesión correctamente en Discord?");
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const registerUser = async () => {
      if (code.length > 0) {
        setLoading(true);
        setError(false);

        try {
          // 1. Register / login user
          const protocol = window.location.protocol;
          const host = window.location.host;
          const pathname = window.location.pathname;
          const currentUrl = `${protocol}//${host}${pathname}`;
          const response = await axios.post(api_v3_register(code, currentUrl));
          if (response.status === 200) {
            console.log(response.data); // DEBUG
            setAuthTokens(
              response.data.access_token,
              response.data.access_token
            );
          } else {
            console.log("Error registering user");
            setError("Error registrando usuario. Inténtalo de nuevo.");
            setLoading(false);
            return;
          }

          // 2. Sign-up into tournament
          const config_reg_tourn = {
            headers: { Authorization: `Bearer ${response.data.access_token}` },
          };

          const response_reg_tourn = await axios.post(
            api_v3_user_register_tournament(tournamentId),
            {}, // no body
            config_reg_tourn
          );
          if (
            response_reg_tourn.status === 200 ||
            response_reg_tourn.status === 202
          ) {
            console.log("User set up in tournament");
            setError("");
            setLoading(false);
          } else {
            console.log("Error setting up user in tournament");
            setError(
              "Error inscribiendo al usuario en el torneo. Inténtalo de nuevo."
            );
            setLoading(false);
            return;
          }
        } catch (error) {
          console.log("error registering user");
          setError("Error actualizando datos del usuario. Inténtalo de nuevo.");
          setLoading(false);
        }
      }
    };

    registerUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  if (!loading && !error) {
    return <RegisterTournamentOk tournamentId={tournamentId} />;
  }
  return (
    <Wrapper>
      <div className="container">
        <video
          className="background-video"
          src={current_background_video}
          muted
          autoPlay
          preload="auto"
          loop
          type="video/mp4"
        ></video>
      </div>
      <Content>
        {loading ? <Loading /> : ""}
        {error ? (
          <div className="info">
            <h2>ERROR EN EL REGISTRO</h2>
            <p>{error}</p>
            <Link to={`/register/tournament/${tournamentId}`}>
              <button className="btn space-around">Reintentar registro</button>
            </Link>
            <p className="more-help">
              <i>
                Si sigues teniendo problemas ponte en contacto con los
                organizadores por discord.
              </i>
            </p>
          </div>
        ) : (
          ""
        )}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .container {
    width: 100%;
    height: 88vh;
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: -1;
  }

  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -10;
    position: absolute;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;

  .more-help {
    margin-top: 6rem;
    font-size: 0.8rem;
  }
`;

export default RegisterTournamentOkPage;
